import type { Fallacy } from "./types";
import { createStory } from "./types";

export const statusQuoBias: Fallacy = {
    id: "status-quo-bias",
    name: "Status Quo Bias",
    emoji: "🪨",
    category: "Otak yang Menipu Diri",
    description: "Kecenderungan **tetap di kondisi sekarang** meski ada opsi lebih baik, karena **sudah terbiasa**.",
    tldr: "\"Udah biasa gini\" bukan alasan logis buat menolak yang lebih baik.",
    detail: "Status Quo Bias adalah kecenderungan **lebih memilih kondisi saat ini** dibandingkan perubahan, meskipun perubahan berpotensi lebih baik. Terkait erat dengan **loss aversion** — kita menganggap risiko perubahan lebih besar daripada potensi keuntungannya.\n\nBias ini menjelaskan mengapa orang bertahan di pekerjaan yang tidak membahagiakan, tetap pakai produk lama, atau menolak kebijakan baru meski data menunjukkan yang lama sudah tidak efektif. Di dunia startup, ini sering jadi **penghambat inovasi**.\n\nCara melawan: Bayangkan kamu **memulai dari nol**. Kalau belum punya sistem yang sekarang, apakah kamu akan memilihnya? Jika tidak, mungkin sudah saatnya berubah.",
    story: createStory("Status Quo Bias", "🪨", {
      hook: {
        title: "\"Udah biasa gini kok.\"",
        body: "Pernah nolak sesuatu yang jelas lebih baik, cuma karena males berubah?",
      },
      convo: {
        claim: "Tim kita disaranin pindah ke tool baru yang bisa naikin efisiensi 40%, tapi **ngapain ganti kalau spreadsheet udah jalan** 3 tahun dan gak ada masalah?",
        response: "Gak ada masalah bukan berarti optimal. **Kamu nolak karena males berubah, bukan karena udah bagus.**",
      },
      reveal: {
        body: "Kamu **lebih milih kondisi sekarang** bukan karena lebih bagus, tapi karena **udah terbiasa**. Risiko berubah keliatan gede, padahal yang kamu korbanin juga gak kecil.",
      },
      insight: {
        title: "Kenapa susah berubah?",
        body: "Karena otak kamu **nganggep risiko berubah lebih gede** daripada keuntungannya. Padahal sering kali yang kamu korbanin dengan bertahan itu justru lebih besar.",
      },
      engagement: {
        title: "Apa yang paling susah kamu ganti meski tau ada yang lebih baik?",
        body: "Kerjaan, tools, atau kebiasaan sehari-hari? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["loss-aversion", "appeal-to-tradition", "sunk-cost", "normalcy-bias"],
  };
